import React, {useState} from "react";
import {CashCoin, CurrencyDollar} from "react-bootstrap-icons";
import {ButtonGroup, FormControl, InputGroup, Modal, Alert} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import {UnsettledTransactionDetail} from "./components/UnsettledTransactionDetail";
import {BiLogoVenmo} from "react-icons/bi";
import {SiCashapp, SiPaypal, SiZelle} from "react-icons/si";
import TimedErrorMessage from "../../components/TimedErrorMessage";
import { useHouseDispatch } from "../../contexts/HouseContext";

const paymentTypes = [
    {type: "CASH", content: <CashCoin/>},
    {type: "VENMO", content: <BiLogoVenmo title="Venmo" />},
    {type: "PAYPAL", content: <SiPaypal title="PayPal" />},
    {type: "CASH_APP", content: <SiCashapp title="CashApp" />},
    {type: "ZELLE", content: <SiZelle title="Zelle" />},
];

export const AddTransactionModal = ({ game, player, show, handleClose }) => {
    const actions = useHouseDispatch();

    const [errorMessage, setErrorMessage] = useState(null);

    const pendingTxn = game.pendingTransaction;

    if (!player || !show) {
        return null;
    }

    const unsettledBuyIns = player.transactions
        .filter(t => (t.type === 'BUY_IN' && !t.isSettled) || (player.pendingCoverTransactionIds.includes(t.id)));

    const showUnsettledBuyIns = pendingTxn.transactionType === "CASH_OUT" && unsettledBuyIns.length > 0;

    const handlePaymentTypeClick = async (e) => {
        e.preventDefault()
        const paymentType = e.target.value
        if (!paymentType) {
            return;
        }
        return actions.updatePendingTransaction(game.id, {
            ...pendingTxn,
            paymentType: paymentType,
            isSettled: paymentType === "CASH",
        });
    }

    const handleHide = async () => {
        handleClose();
        await actions.resetCoverTransactions(game.id, player.id);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const target = e.target
        const data = Array.from(target.elements)
            .filter((i) => i.name)
            .reduce((acc, i) => Object.assign(acc, {[i.name]: i.value}), {})
        data.paymentType = pendingTxn.paymentType
        data.isSettled = pendingTxn.isSettled
        data.type = pendingTxn.transactionType
        data.amount = parseFloat(pendingTxn.amount)

        const result = pendingTxn.transactionType === "CASH_OUT"
            ? await actions.createCashOutTransactions(game.id, player.id, data)
            : await actions.createTransaction(game.id, player.id, data);

        if (result.error) {
            console.log("transaction submit failed", { result });
            return;
        }

        await handleHide();
    };

    const handleTransactionTypeChange = (type) => {
        return async () => {
            await actions.updatePendingTransaction(game.id, { 
                ...pendingTxn, transactionType: type,
            });
        }
    }

    const handleAmountChange = async (e) => {
        await actions.updatePendingTransaction(game.id, { ...pendingTxn, amount: e.target.value })
    }

    return (
        <Modal show={show} onHide={handleHide}>
            <Form onSubmit={handleSubmit}>
                <Modal.Header className="justify-content-between">
                    <Col xs={7}>Add a transaction for <span className="fw-bolder">{player.name}</span></Col>
                    <Col xs={"auto"}>
                        <ButtonGroup>
                            <Button
                                variant={"outline-success"}
                                active={pendingTxn.transactionType === "BUY_IN"}
                                value={"BUY_IN"}
                                onClick={handleTransactionTypeChange("BUY_IN")}
                            >Buy In</Button>
                            <Button
                                variant={"outline-success"}
                                active={pendingTxn.transactionType === "CASH_OUT"}
                                value={"CASH_OUT"}
                                onClick={handleTransactionTypeChange("CASH_OUT")}
                            >Cash Out</Button>
                        </ButtonGroup>
                    </Col>
                </Modal.Header>
                <Modal.Body>
                    <Row className="justify-content-between mb-3">
                        <ButtonGroup>
                            {paymentTypes.map(
                                (t, i) =>
                                    <Button
                                        key={i}
                                        active={t.type === pendingTxn.paymentType}
                                        value={t.type}
                                        onClick={handlePaymentTypeClick}>{t.content}
                                    </Button>
                            )}
                        </ButtonGroup>
                    </Row>
                    <Row className="justify-content-center mb-3">
                        <Col xs={7}>
                            <InputGroup>
                                <InputGroup.Text><CurrencyDollar/></InputGroup.Text>
                                <FormControl
                                    type="text"
                                    inputMode="numeric"
                                    name="amount"
                                    value={pendingTxn.amount}
                                    onChange={handleAmountChange}
                                />
                            </InputGroup>
                        </Col>
                        <Col xs="auto">
                            <Form.Check
                                type="switch"
                                name="isSettled"
                                label="Settled"
                                checked={pendingTxn.isSettled}
                                onChange={() => actions.updatePendingTransaction(game.id, { ...pendingTxn, isSettled: !pendingTxn.isSettled})}
                            />
                        </Col>
                    </Row>
                    {showUnsettledBuyIns && (
                        <Row>
                            <Col>
                                <Alert variant="warning">
                                    You have <b>{unsettledBuyIns.length}</b> unsettled buy-ins.
                                    {unsettledBuyIns.map(t => (
                                        <UnsettledTransactionDetail key={t.id} gameId={game.id} transaction={t} playerId={player.id} setErrorMessage={setErrorMessage}></UnsettledTransactionDetail>
                                    ))}
                                    <TimedErrorMessage message={errorMessage} done={() => setErrorMessage(null)} />
                                </Alert>
                            </Col>
                        </Row>
                    )}
                    <Row className="justify-content-between">
                        <Col xs="auto">
                            <Button variant="danger" onClick={handleHide}>Cancel</Button>
                        </Col>
                        <Col xs="auto">
                            <Button variant="success" type="submit">Submit</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Form>
        </Modal>
    )
}
